<template>
  <q-dialog v-model="shown">
    <q-card
      :style="{ 'width': '450px', 'max-width': '95%' }"
      @keyup.enter="emitOrderItem"
    >
      <q-card-section
        class="text-h5"
      >
        Add Cashout
      </q-card-section>

      <q-card-section
        v-if="orderItem"
      >
        <div class="row items-center q-col-gutter-sm">
          <q-input
            ref="orderItemAmount"
            v-model.number="orderItem.amount"
            class="col"
            label="Amount"
            :prefix="currentCircuit.localeCurrencySymbol"
            type="number"
            step="0.01"
            :rules="[
              val => val !== 0 || 'Cannot be zero',
              val => val !== null && val !== '' || 'Cannot be blank'
            ]"
          />
        </div>
      </q-card-section>

      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Cancel"
          :outline="true"
        />
        <q-btn
          v-close-popup
          label="Add Cashout"
          color="primary"
          @click="emitOrderItem"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'RegisterButtonCashoutDialog',
  configuration: ['currentCircuit'],
  emits: ['update-cashout'],
  data () {
    return {
      shown: false,
      orderItem: null
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.orderItem = null
      }
    }
  },
  methods: {
    async show (orderItem) {
      this.orderItem = orderItem

      this.shown = true

      await this.$nextTick() // Wait for elements to be rendered
      this.$refs.orderItemAmount.select()
    },
    emitOrderItem () {
      this.$emit('update-cashout', this.orderItem)
      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-wrap: wrap;
}
.button {
  padding: 10px;
  height: 100%;
}
</style>
